import { render, staticRenderFns } from "./energyResearches.vue?vue&type=template&id=4bb1abf8&"
import script from "./energyResearches.vue?vue&type=script&lang=js&"
export * from "./energyResearches.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports